export const ps4Controllers =
  'https://cdn.pixabay.com/photo/2021/09/07/07/11/game-console-6603120_1280.jpg';

export const joyStickController =
  'https://cdn.pixabay.com/photo/2019/07/06/20/31/joystick-4321216_1280.jpg';

export const mineCraft =
  'https://cdn.pixabay.com/photo/2015/03/01/19/32/minecraft-655158_1280.jpg';

export const xbox =
  'https://cdn.pixabay.com/photo/2016/01/12/16/38/video-games-1136046_1280.jpg';

export const sega =
  'https://images.unsplash.com/photo-1625805866449-3589fe3f71a3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80';

export const arcade =
  'https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80';

export const pcGamer =
  'https://images.unsplash.com/photo-1560419015-7c427e8ae5ba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80';

export const lanParty =
  'https://images.unsplash.com/photo-1560253023-3ec5d502959f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80';

export const gameBoy =
  'https://images.unsplash.com/photo-1631896928992-90e5a2cc7a4e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80';

export const ps2ConsoleAndGames =
  'https://images.unsplash.com/photo-1593277992013-05e17a5f417d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80';

export const modernWarfare =
  'https://images.unsplash.com/photo-1616757857818-5c6eea38ee17?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80';

export const ps4 =
  'https://images.unsplash.com/photo-1507457379470-08b800bebc67?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1809&q=80';

export const mobileGaming =
  'https://images.unsplash.com/photo-1616565441366-34a5fe33fe42?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2064&q=80';

export const nintendoSwitch =
  'https://images.unsplash.com/photo-1538895194639-f50554a2ca24?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1734&q=80';

export const camera =
  'https://cdn.pixabay.com/photo/2016/01/09/18/27/camera-1130731_1280.jpg';

export const miamiPanrama =
  'https://cdn.pixabay.com/photo/2017/03/05/00/34/panorama-2117310_1280.jpg';

export const cinqueTerreItaly =
  'https://cdn.pixabay.com/photo/2019/03/31/14/31/houses-4093227_1280.jpg';

export const boraBora =
  'https://cdn.pixabay.com/photo/2017/12/16/22/22/bora-bora-3023437_1280.jpg';

export const hamburg =
  'https://cdn.pixabay.com/photo/2018/11/29/21/19/hamburg-3846525_1280.jpg';

export const castle =
  'https://cdn.pixabay.com/photo/2018/01/21/01/46/architecture-3095716_1280.jpg';

export const stoneBridgePanorama =
  'https://cdn.pixabay.com/photo/2017/12/16/22/23/regensburg-3023439_1280.jpg';

export const fireworksAsia =
  'https://cdn.pixabay.com/photo/2016/11/14/03/21/fireworks-1822479_1280.jpg';

export const waterfall =
  'https://cdn.pixabay.com/photo/2018/04/27/08/55/water-3354062_1280.jpg';

export const london =
  'https://cdn.pixabay.com/photo/2014/11/13/23/34/palace-530055_1280.jpg';

export const mountains =
  'https://cdn.pixabay.com/photo/2019/08/22/14/14/mountains-4423621_1280.jpg';

export const temple =
  'https://cdn.pixabay.com/photo/2016/09/15/01/57/temple-1670926_1280.jpg';

export const rainbow =
  'https://cdn.pixabay.com/photo/2016/06/20/03/21/rainbow-1467988_1280.jpg';

export const swimmingInOcean =
  'https://cdn.pixabay.com/photo/2018/03/27/15/04/women-3266211_1280.jpg';

export const mosque =
  'https://cdn.pixabay.com/photo/2015/01/28/23/10/mosque-615415_1280.jpg';

export const trainInScotland =
  'https://cdn.pixabay.com/photo/2019/07/25/09/38/train-4362166_1280.jpg';

export const beachFootPrints =
  'https://cdn.pixabay.com/photo/2021/05/29/03/00/beach-6292382_1280.jpg';

export const archesNationalPark =
  'https://cdn.pixabay.com/photo/2016/11/21/17/44/arches-national-park-1846759_1280.jpg';

export const iceland =
  'https://cdn.pixabay.com/photo/2018/09/04/18/28/husavik-3654390_1280.jpg';

export const venice =
  'https://cdn.pixabay.com/photo/2021/08/03/11/48/canal-6519196_1280.jpg';

export const greekMonastery =
  'https://cdn.pixabay.com/photo/2019/05/09/19/13/alley-4191906_1280.jpg';

export const monument =
  'https://cdn.pixabay.com/photo/2019/10/01/21/42/caravansary-4519442_1280.jpg';

export const operaHouse =
  'https://cdn.pixabay.com/photo/2018/05/07/22/08/opera-house-3381786_1280.jpg';

export const copenhagen =
  'https://cdn.pixabay.com/photo/2019/03/13/11/04/copenhagen-4052654_1280.jpg';

export const lightHouse =
  'https://cdn.pixabay.com/photo/2015/06/24/16/54/lighthouse-820431_1280.jpg';

export const acropolis =
  'https://cdn.pixabay.com/photo/2017/09/07/16/50/acropolis-2725918_1280.jpg';

export const osaka =
  'https://cdn.pixabay.com/photo/2017/01/28/02/24/japan-2014617_1280.jpg';

export const newZealand =
  'https://cdn.pixabay.com/photo/2019/11/29/14/29/new-zealand-4661427_1280.jpg';

export const vacationPrep =
  'https://cdn.pixabay.com/photo/2017/10/23/05/56/summer-2880261_1280.jpg';
